import React from 'react';
import {Scrollbar} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {StatusItem} from './StatusItems';
import styles from '../styles/historyContent.module.scss';
import {fetchMore} from '../../Common/actions';
import {Record, Column, formsStore} from '../../../../../../stores/Form';
import {useState} from 'react';
import {statusLogDefaultFields} from '../consts';
import {EmptyState} from './EmptyState';
import {SearchBlock} from '../../Common/components/SearchBlock';
import {SettingsPanelCol} from '../../Common/consts';

type Props = {
    statuses: Record[];
    shouldFetchMore: boolean;
    statusColorMap: any[];
    isLegacyStore: boolean;
    enabledCols: string[];
    applySettings: (cols: SettingsPanelCol[]) => Promise<void>;
    subformType: priority.netitems.form.SubformType;
};

export const StatusesTabContent = ({
    statuses,
    shouldFetchMore,
    statusColorMap,
    isLegacyStore,
    enabledCols,
    applySettings,
    subformType
}: Props) => {
    const [searchQuery, setSearchQuery] = useState('');

    const statusItems = [];
    const curForm = formsStore.getActiveForm();

    const searchableColIds = [...statusLogDefaultFields, ...enabledCols].reduce((acc, colName) => {
        const column: Column = curForm.getColumnByName(colName);
        if (
            column &&
            column?.Type !== priority.netitems.form.ColumnType.Boolean &&
            column?.Type !== priority.netitems.form.ColumnType.Char
        ) {
            acc.push(column.ID);
        }
        return acc;
    }, []);

    const isInSearch = (status: Record) => {
        return (
            !searchQuery ||
            searchableColIds.some(colId =>
                status.fieldsMap
                    .get(Number(colId))
                    ?.origValue?.toString()
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
            )
        );
    };

    statuses.forEach((status, idx) => {
        if (isInSearch(status)) {
            statusItems.push(
                <StatusItem
                    statuses={statuses}
                    idx={idx}
                    shouldFetchMore={shouldFetchMore}
                    key={idx}
                    statusColorMap={statusColorMap}
                    isLegacyStore={isLegacyStore}
                    enabledCols={enabledCols}
                />
            );
        }
    });

    const handleScrollEnd = async () => {
        if (shouldFetchMore) {
            fetchMore(statuses[0].parentForm, statuses);
        }
    };

    return (
        <div className={styles.tabContainer}>
            <SearchBlock
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
                isServerSearch={false}
                records={statuses}
                defaultCols={statusLogDefaultFields}
                enabledCols={enabledCols}
                componentClasses={styles.searchBlockWrapper}
                applySettings={applySettings}
                subformType={subformType}
            />
            {statusItems.length > 0 ? (
                <Scrollbar onScrollEnd={handleScrollEnd}>{statusItems}</Scrollbar>
            ) : (
                <EmptyState isFastSearch={true} />
            )}
        </div>
    );
};
